import type * as React from 'react';

import { Input } from '../../../components/ui/input';
import { cn } from '../../../components/ui/utils';

/**
 * Ячейка-поле: таблица отчёта правится как таблица, а не как десять форм.
 *
 * Рамка появляется под курсором — иначе страница из сорока строк выглядит
 * решёткой из рамок и читать её невозможно.
 */
export function CellInput({
  value,
  onChange,
  disabled,
  align,
  placeholder,
  className,
  label,
}: {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  align?: 'right';
  placeholder?: string;
  className?: string;
  /** Подпись для чтения с экрана: у ячейки видимой подписи нет. */
  label: string;
}): React.ReactElement {
  return (
    <Input
      aria-label={label}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      className={cn(
        'h-8 border-transparent bg-transparent px-1.5 shadow-none hover:border-input',
        align === 'right' && 'text-right tabular-nums',
        className,
      )}
    />
  );
}
